<template>
  <div>
    	<div class="profile-container">
    		<el-row class="header">
		      <el-col :span="18" class="header-left">
		        <div class="header-avatar">
		          <img :src="avatar" />
		        </div>
		        <div class="header-content">
		          <div class="title">
		            {{message}}<i class="el-icon-edit-outline" @click="openDialog" style="margin-left: 8px;cursor:pointer;"></i>
		          </div>
		          <div class="sub">
		          	<div>
                        <span>公司：{{companyName}}</span>
		          		<!-- <span v-if="role == 4">公司:爱普兰</span>
		          		<span v-if="role == 2 || role == 3">公司：{{companyName}}</span> -->
		          	</div>
		          	<div>
		          		地址:{{address}}
		          	</div>
		          </div>
		        </div>
		      </el-col>
		      <el-col :span="6">
		      </el-col>
		    </el-row>
    	</div>
    	<el-dialog title="个人信息修改" :visible.sync="myDialog" width="500px">
				<div>
						<table style="border-collapse:separate; border-spacing:0px 10px;">
							<tr>
								<td style="font-size: 14px;font-weight: bold;">头像</td>
								<td>
									<div style="margin-left: 15px;">
										<el-upload
										  class="avatar-uploader"
										  :action="updateAction"
										  :show-file-list="false"
										  :on-success="handleAvatarSuccess"
										  :before-upload="beforeAvatarUpload">
										  <img v-if="updateAvatar" :src="updateAvatar" class="avatar">
										  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
										</el-upload>
									</div>
								</td>
							</tr>
							<tr>
								<td style="font-size: 14px;font-weight: bold;">昵称</td>
								<td>
									<el-input v-model="updateNickname" style="margin-left: 15px;"></el-input>
								</td>
							</tr>
							<tr>
								<td style="font-size: 14px;font-weight: bold;">地址</td>
								<td>
									<el-input v-model="updateAddress" type="textarea" :rows="3" style="margin-left: 15px;"></el-input>
								</td>
							</tr>
						</table>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="myDialog = false">取 消</el-button>
	    			<el-button type="primary" @click="updateInfo">确 定</el-button>
				</div>
			</el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import Cookies from 'js-cookie'

export default {
  name: 'profile',
  data() {
    return {
    	avatar:'',
    	nickname:'',
    	message:'',
    	companyName:'',
    	role:'',
    	address:'',
    	updateAvatar:'',
    	updateAddress:'',
    	updateNickname:'',
    	myDialog:false,
    	updateAction:this.$store.getters.getApiValue+"/product/uploadImage.do"
    }
  },
  mounted() {
  	this.initPage();
  },
  methods:{
  	initPage(){
  		var thiz = this;
	    axios.get(this.$store.getters.getApiValue+'/srsUser/getMyData.do')
	    		.then(function (response) {
						var data = response.data;
						if(data.status == "200"){
						   thiz.avatar = data.data.avatar;
						   thiz.nickname = data.data.nickname;
						   thiz.companyName = data.data.companyName;
						   thiz.role = data.data.role;
						   thiz.address = data.data.location;
						   var myDate = new Date();
						   if(myDate.getHours()>= 0 && myDate.getHours() < 4){
						   		thiz.message = "深夜好，"+data.data.nickname;
						   }else if(myDate.getHours()>= 4 && myDate.getHours() < 6){
						   		thiz.message = "凌晨好，"+data.data.nickname;
						   }else if(myDate.getHours()>= 6 && myDate.getHours() < 8){
						   		thiz.message = "早上好，"+data.data.nickname;
						   }else if(myDate.getHours()>= 8 && myDate.getHours() < 12){
						   		thiz.message = "上午好，"+data.data.nickname;
						   }else if(myDate.getHours()>= 12 && myDate.getHours() < 14){
						   		thiz.message = "中午好，"+data.data.nickname;
						   }else if(myDate.getHours()>= 14 && myDate.getHours() < 18){
						   		thiz.message = "下午好，"+data.data.nickname;
						   }else if(myDate.getHours()>= 18 && myDate.getHours() < 24){
						   		thiz.message = "晚上好，"+data.data.nickname;
						   }
						}
					}).catch(function (error) {
						console.log(error);
					});
  	},
  	updateInfo(){
  		var thiz = this;
	    axios.get(this.$store.getters.getApiValue+'/srsUser/updateMyData.do',{
	    	params:{
	    		avatar:this.updateAvatar,
	    		location:this.updateAddress,
	    		nickname:this.updateNickname
	    	}
	    }).then(function (response) {
						var data = response.data;
						if(data.status == "200"){
							Cookies.set("srs_avatar",thiz.updateAvatar);
							Cookies.set("srs_nickname",thiz.updateNickname);
							thiz.initPage();
							thiz.myDialog = false;
						  thiz.$message.success("修改成功!");
						}else{
							thiz.$message.error(data.message);
						}
					}).catch(function (error) {
						thiz.$message.error("系统异常!请与管理员联系!");
						console.log(error);
					});
  	},
  	openDialog(){
  		this.updateAvatar = this.avatar;
  		this.updateAddress = this.address;
  		this.updateNickname = this.nickname;
  		this.myDialog = true;
  	},
  	handleAvatarSuccess(res, file) {
  		this.updateAvatar = res.data;
  		console.log(this.updateAvatar)
    },
    beforeAvatarUpload(file) {
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../../assets/styl/variables.styl'

title-color = #464646
title-sub = #8c8c8c

.profile-container
  .el-card
    font-size 14px

  @extend .edenfont-content
  width 100%
  .header
    padding 15px
    margin -15px
    box-sizing unset
    background white
    height 130px
    &-left
      height 100%
      display flex
      box-sizing border-box
      align-items center
    &-avatar
      margin-left 20px
      display inline-block
      vertical-align middle
      width 100px
      img 
        border-radius 50%
        width 100%
    &-content
      flex 1
      margin-left 20px
      height 85px
      display inline-block
      vertical-align middle
      .title
        font-size 18px
        font-weight bold
        color title-color
        span
          cursor pointer
          color main-color
          &:hover
            text-decoration-line underline
      .sub
        margin-top 20px
        color title-sub
        font-size 14px
      .sub:last-child
        margin-top 10px

    &__right
      .el-card:not(:first-child)
        margin-top 20px
    .card-title
      color #585858
</style>

<style>
	.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 50px;
    height: 50px;
    display: block;
  }
</style>